import React from 'react';
import { createSvgIcon } from '@mui/material';

const CheckDoubleIcon = createSvgIcon(
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0857 5.65742C18.4131 5.98083 18.4164 6.50846 18.093 6.83591L11.013 14.0045C10.5059 14.5178 9.67949 14.5178 9.17243 14.0045L5.79609 10.5859C5.47268 10.2585 5.47596 9.73083 5.80341 9.40742C6.13087 9.08401 6.65849 9.08729 6.9819 9.41474L10.0927 12.5644L16.9072 5.66474C17.2306 5.33729 17.7582 5.33401 18.0857 5.65742Z"
      fill="currentColor"
    />
    <path
      opacity="0.24"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5301 7.32344C12.8575 7.64685 12.8608 8.17447 12.5374 8.50193L10.6855 10.3769C10.3621 10.7044 9.8345 10.7077 9.50704 10.3842C9.17959 10.0608 9.17631 9.53321 9.49972 9.20576L11.3516 7.33076C11.675 7.0033 12.2026 7.00003 12.5301 7.32344ZM1.86443 10.2438C2.18987 9.91832 2.71751 9.91831 3.04295 10.2437L5.95966 13.1604C6.2851 13.4858 6.2851 14.0135 5.95967 14.3389C5.63423 14.6644 5.10659 14.6644 4.78115 14.3389L1.86444 11.4223C1.539 11.0968 1.539 10.5692 1.86443 10.2438Z"
      fill="currentColor"
    />
  </svg>,
  'CheckDoubleIcon',
);

export default CheckDoubleIcon;
